export type AssociationItem = {
  id: string;
  text_en?: string;
  text_fr?: string;
  text_ar?: string;
  image?: string;
  matchKey: string;
};

export type AssociationConfig = {
  statement?: string;
  leftTitle_en?: string;
  leftTitle_fr?: string;
  leftTitle_ar?: string;
  rightTitle_en?: string;
  rightTitle_fr?: string;
  rightTitle_ar?: string;
  revealOnSubmit?: boolean;
  left: AssociationItem[];
  right: AssociationItem[];
};

export const createEmptyAssociationConfig = (): AssociationConfig => ({
  statement: "",
  leftTitle_en: "",
  leftTitle_fr: "",
  leftTitle_ar: "",
  rightTitle_en: "",
  rightTitle_fr: "",
  rightTitle_ar: "",
  left: [],
  right: [],
  revealOnSubmit: true,
});
